import { useEffect } from 'react'

import { publishWorkspaceTabTitle } from './publishWorkspaceTabTitle'
import { useOptionalWorkspaceTabsActions } from './WorkspaceTabsContext'

/**
 * Page-owned workspace tab title. Call from any routed page to update the
 * active tab's label as the user drills down (search query, entity name, …).
 * Pass `null` to clear a sticky customLabel (e.g. while document metadata
 * loads). When omitted / undefined, the tab keeps its current label.
 * No-ops when workspace tabs are not mounted (legacy layout).
 */
export function useWorkspaceTabTitle(title: string | null | undefined): void {
  const setActiveTabTitle = useOptionalWorkspaceTabsActions()?.setActiveTabTitle

  useEffect(() => {
    publishWorkspaceTabTitle(setActiveTabTitle, title)
  }, [setActiveTabTitle, title])
}
